import styled from 'styled-components';

import { CircularProgress } from '@mui/material';

const Container = styled.div`
  display: flex;
  padding: 2rem;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`;

interface Props {
  file: {
    file: any;
    content_type: string;
  };
  isLoading: boolean;
}

export const PDFPreview: React.FC<Props> = ({ file, isLoading }) => {
  if (isLoading) {
    return (
      <Container>
        <LoadingContainer>
          <CircularProgress size={30} thickness={3} />
        </LoadingContainer>
      </Container>
    );
  }

  if (!file) return null; // Render null if there is no file to display

  return (
    <Container>
      <p>PDF previews cannot be shown. This feature is coming soon.</p>
    </Container>
  );
};
